import React, { useEffect, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { getAllCartItems, removeItemFromCart } from "../../../redux/features/cart/cartServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faCheckCircle, faTrashCan, faXmark } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import Capricom from '../../../assets/images/astro/1.png';
import Aquarius from '../../../assets/images/astro/2.png';
import Pisces from '../../../assets/images/astro/3.png';
import Aries from '../../../assets/images/astro/4.png';
import Taurus from '../../../assets/images/astro/5.png';
import Gemini from '../../../assets/images/astro/6.png';
import Cancer from '../../../assets/images/astro/7.png';
import Leo from '../../../assets/images/astro/8.png';
import Virgo from '../../../assets/images/astro/9.png';
import Libra from '../../../assets/images/astro/10.png';
import Scorpio from '../../../assets/images/astro/11.png';
import Sagittarius from '../../../assets/images/astro/12.png';
import { setShouldRefreshCount } from "../../../redux/features/cart/cartSlice";
import NoResultsFoundImg from "../../../assets/images/empty_cart.png";
import { showToast } from "../../../components/ToastMsg";
import { useTranslation } from "react-i18next";
import WebxpayPayment from "../WebxpayPayment/WebxpayPayment";
import { createNewOrderForWallet } from "../../../redux/features/order/orderServices";
import { setShouldRefreshWallet } from "../../../redux/features/wallet/walletSlice";
import BeatLoader from "react-spinners/BeatLoader";

const astroImages = {
    1: Capricom,
    2: Aquarius,
    3: Pisces,
    4: Aries,
    5: Taurus,
    6: Gemini,
    7: Cancer,
    8: Leo,
    9: Virgo,
    10: Libra,
    11: Scorpio,
    12: Sagittarius,
};

const Cart = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { isCartItemsLoading, cartItems } = useSelector((state) => state.cart.allCartItems);
    const { wallet, shouldRefreshWallet } = useSelector((state) => state.wallet);
    const { walletDetails } = useSelector((state) => state.wallet.walletDetails);
    const { isWalletOrderCreating } = useSelector((state) => state.order.walletOrderDetails);

    const [expandedBrand, setExpandedBrand] = useState({});
    const [isParam, setParam] = useState({ statusCode: '', message: '' });
    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        dispatch(getAllCartItems());
    }, [dispatch]);


    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const statusCode = queryParams.get("status_code");
        const message = queryParams.get("message");
        setParam({
            statusCode: statusCode,
            message: message
        });
        if (statusCode === '1') {
            setOpen(true);
        }
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            const url = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, url);
        }, 3000); // 3000ms = 3 seconds

        return () => clearTimeout(timer); // cleanup if component unmounts
    }, []);

    const groupedItems = cartItems?.reduce((acc, item) => {
        const key = item.ticket.lottery.lottery_brand_day.id;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
    }, {});

    const toggleDetails = (id) => {
        setExpandedBrand((prev) => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const removeItem = async (ticket) => {
        try {
            const data = {
                ticket_id: ticket.ticket.id
            };
            const response = await dispatch(removeItemFromCart(data)).unwrap();
            if (response.success) {
                dispatch(setShouldRefreshCount(true));
                dispatch(getAllCartItems());
            }
        } catch (error) {
            showToast('error', error.message);
        }
    };

    const totalAmount = Object.values(groupedItems || {}).reduce((total, group) => {
        return total + group.reduce((subTotal, item) => subTotal + item.ticket.lottery.price, 0);
    }, 0);

    const totalTickets = Object.values(groupedItems || {}).reduce((total, group) => total + group.length, 0);

    const payThroughWallet = async () => {
        const data = {
            amount: totalAmount,
            wallet_id: walletDetails?.id
        };
        try {
            const response = await dispatch(createNewOrderForWallet(data)).unwrap();
            if (response.success === true) {
                setOpen(true);
                dispatch(getAllCartItems());
                dispatch(setShouldRefreshCount(true));
                dispatch(setShouldRefreshWallet(true));
            }
        } catch (error) {
            showToast("error", error.message);
            dispatch(getAllCartItems());
            dispatch(setShouldRefreshCount(true));
            showToast('error', error)
        }
    }

    return (
        <div className={styles.cartContainer}>
            <div className="main-container">
                <div className={`container-content ${styles.cartCard}`}>
                    <div className={styles.homeHeader}>
                        <h1 className={styles.listingTitle}>{(isCartItemsLoading || cartItems?.length > 0) && `My CART`}</h1>
                    </div>
                    {isCartItemsLoading ?
                        <>
                            <div className={styles.cartBody}>
                                <Skeleton height={80} className={styles.ticketBrand} style={{ marginBottom: '10px' }} />
                                <Skeleton height={80} className={styles.ticketBrand} style={{ marginBottom: '10px' }} />
                                <Skeleton height={80} className={styles.ticketBrand} />
                            </div>
                            <div className={styles.cartFooter}>
                                <div className={styles.ticketDetails}>
                                    <Skeleton height={20} className={styles.rowOne} />
                                    <Skeleton height={20} className={styles.rowOne} />
                                    <Skeleton height={20} className={styles.rowOne} />
                                </div>
                            </div>
                            <div className={styles.footerBtn}>
                                <Skeleton height={40} width={150} style={{ borderRadius: '100px' }} />
                            </div>
                        </>
                        : cartItems?.length > 0 ?
                            <>
                                <div className={styles.cartBody}>
                                    {Object.entries(groupedItems || {}).map(([groupKey, items]) => (
                                        <div key={groupKey}>
                                            <div className={styles.ticketBrand}>
                                                <div className={styles.ticketBrandHeader} onClick={() => toggleDetails(groupKey)}>
                                                    <div className={styles.ticketBrandHeaderLeft}>
                                                        <FontAwesomeIcon
                                                            icon={faAngleDown}
                                                            className={styles.dropownIcon}
                                                            style={{
                                                                transform: expandedBrand[groupKey] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                transition: 'transform 0.3s ease',
                                                            }}
                                                        />
                                                        <img
                                                            src={items[0].ticket.lottery.lottery_brand_day.lottery_brand.logo_url}
                                                            alt="brand logo"
                                                            className={styles.brandImg}
                                                        />
                                                        <p className={styles.brandName}>{t(items[0].ticket.lottery.lottery_brand_day.lottery_brand.name)}</p>
                                                    </div>
                                                    <div className={styles.ticketBrandHeaderRight}>
                                                        <p className={styles.ticketPrice}>
                                                            {t(`Rs`)} {(items.reduce((sum, item) => sum + item.ticket.lottery.price, 0)).toFixed(2)}
                                                        </p>
                                                    </div>
                                                </div>
                                                {expandedBrand[groupKey] &&
                                                    items.map((item, index) => (
                                                        <div key={`${item.id}-${index}`}>
                                                            <div className={styles.ticketBrandBody}>
                                                                {item.ticket.lottery.lottery_brand_day.lottery_brand.code === 'MASAM' && (
                                                                    <div className={styles.masamNumberRow}>
                                                                        <div className={styles.masamNumbers}>
                                                                            <p className={styles.masamResultsLetter}>{item.ticket.masam.char}</p>
                                                                            {item.ticket.masam.recd.split("").map((char, i) => (
                                                                                <p key={i} className={styles.masamResultNumber}>{char}</p>
                                                                            ))}
                                                                        </div>
                                                                        <FontAwesomeIcon icon={faTrashCan} className={styles.deleteIcon} onClick={() => removeItem(item)} />
                                                                    </div>
                                                                )}
                                                                {item.ticket.lottery.lottery_brand_day.lottery_brand.code === 'MEPO' && (
                                                                    <div className={styles.masamNumberRow}>
                                                                        <div className={styles.masamNumbers}>
                                                                            <p className={styles.masamResultsLetter}>{item.ticket.mepo.char}</p>
                                                                            <p className={styles.masamResultSpNumber}>{item.ticket.mepo.sno.padStart(2, '0')}</p>
                                                                            <p className={styles.masamResultNumber}>{item.ticket.mepo.n1.padStart(2, '0')}</p>
                                                                            <p className={styles.masamResultNumber}>{item.ticket.mepo.n2.padStart(2, '0')}</p>
                                                                            <p className={styles.masamResultNumber}>{item.ticket.mepo.n3.padStart(2, '0')}</p>
                                                                            <p className={styles.masamResultNumber}>{item.ticket.mepo.n4.padStart(2, '0')}</p>
                                                                        </div>
                                                                        <FontAwesomeIcon icon={faTrashCan} className={styles.deleteIcon} onClick={() => removeItem(item)} />
                                                                    </div>
                                                                )}
                                                                {item.ticket.lottery.lottery_brand_day.lottery_brand.code === 'ADSA' && (
                                                                    <div className={styles.masamNumberRow}>
                                                                        <div className={styles.masamNumbers}>
                                                                            <p className={styles.masamResultsLetter}>{item.ticket.adsa.char}</p>
                                                                            <p className={`${styles.adsaResultNumberA} ${styles.masamResultNumber}`}>{item.ticket.adsa.arange.padStart(2, '0')}</p>
                                                                            <p className={`${styles.adsaResultNumberB} ${styles.masamResultNumber}`}>{item.ticket.adsa.brange.padStart(3, '0')}</p>
                                                                            <p className={`${styles.adsaResultNumberC} ${styles.masamResultNumber}`}>{item.ticket.adsa.crange.padStart(4, '0')}</p>
                                                                        </div>
                                                                        <FontAwesomeIcon icon={faTrashCan} className={styles.deleteIcon} onClick={() => removeItem(item)} />
                                                                    </div>
                                                                )}
                                                                {item.ticket.lottery.lottery_brand_day.lottery_brand.code === 'DHNI' &&
                                                                    <div className={styles.masamNumberRow}>
                                                                        <div className={styles.masamNumbers}>
                                                                            <p className={styles.dhniResultsLetter}>{item.ticket.dhni.char1}</p>
                                                                            <p className={styles.dhniResultsLetter}>{item.ticket.dhni.char2}</p>
                                                                            <p className={styles.dhniResultNumber}>{item.ticket.dhni.n1.padStart(2, '0')}</p>
                                                                            <p className={styles.dhniResultNumber}>{item.ticket.dhni.n2.padStart(2, '0')}</p>
                                                                            <p className={styles.dhniResultNumber}>{item.ticket.dhni.n3.padStart(2, '0')}</p>
                                                                            <p className={styles.dhniResultNumber}>{item.ticket.dhni.n4.padStart(2, '0')}</p>
                                                                            <p className={styles.dhniResultNumberSp}>{item.ticket.dhni.special.padStart(5, '0')}</p>
                                                                        </div>
                                                                        <FontAwesomeIcon icon={faTrashCan} className={styles.deleteIcon} onClick={() => removeItem(item)} />
                                                                    </div>
                                                                }
                                                                {item.ticket.lottery.lottery_brand_day.lottery_brand.code === 'GOVI' && (
                                                                    <div className={styles.masamNumberRow}>
                                                                        <div className={styles.masamNumbers}>
                                                                            <p className={styles.masamResultsLetter}>{item.ticket.govi.char1}</p>
                                                                            <p className={styles.masamResultsLetter}>{item.ticket.govi.char2}</p>
                                                                            <p className={styles.masamResultNumber}>{item.ticket.govi.n1.padStart(2, '0')}</p>
                                                                            <p className={styles.masamResultNumber}>{item.ticket.govi.n2.padStart(2, '0')}</p>
                                                                            <p className={styles.masamResultNumber}>{item.ticket.govi.n3.padStart(2, '0')}</p>
                                                                            <p className={styles.masamResultNumber}>{item.ticket.govi.n4.padStart(2, '0')}</p>
                                                                        </div>
                                                                        <FontAwesomeIcon icon={faTrashCan} className={styles.deleteIcon} onClick={() => removeItem(item)} />
                                                                    </div>
                                                                )}
                                                                {item.ticket.lottery.lottery_brand_day.lottery_brand.code === 'HADA' && (
                                                                    <div className={styles.masamNumberRow}>
                                                                        <div className={styles.hadaCol}>
                                                                            <div className={styles.hadaLeftCol}>
                                                                                <img src={astroImages[item.ticket.hada.lagna]} alt={`Image ${item.ticket.hada.lagna}`} className={styles.hadaAstro} />
                                                                            </div>
                                                                            <div className={styles.hadaRighttCol}>
                                                                                <div className={styles.hadaNumbers}>
                                                                                    <p className={styles.dhniResultNumber}>{item.ticket.hada.n1.padStart(2, '0')}</p>
                                                                                    <p className={styles.dhniResultNumber}>{item.ticket.hada.n2.padStart(2, '0')}</p>
                                                                                    <p className={styles.dhniResultNumber}>{item.ticket.hada.n3.padStart(2, '0')}</p>
                                                                                    <p className={styles.dhniResultNumber}>{item.ticket.hada.n4.padStart(2, '0')}</p>
                                                                                    <p className={styles.hadaSpecial}>{item.ticket.hada.special}</p>
                                                                                    <p className={styles.hadaDaywaLetter}>{item.ticket.hada.dayn}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <FontAwesomeIcon icon={faTrashCan} className={styles.deleteIcon} onClick={() => removeItem(item)} />
                                                                    </div>
                                                                )}
                                                                {item.ticket.lottery.lottery_brand_day.lottery_brand.code === 'JAYA' && (
                                                                    <div className={styles.masamNumberRow}>
                                                                        <div className={styles.masamNumbers}>
                                                                            <p className={styles.masamResultsLetter}>{item.ticket.jaya.char}</p>
                                                                            {item.ticket.jaya.recd.split("").map((char, i) => (
                                                                                <p key={i} className={styles.masamResultNumber}>{char}</p>
                                                                            ))}
                                                                        </div>
                                                                        <FontAwesomeIcon icon={faTrashCan} className={styles.deleteIcon} onClick={() => removeItem(item)} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className={styles.cartFooter}>
                                    <div className={styles.ticketDetails}>
                                        <div className={styles.rowOne}>
                                            <p>{t(`Ticket Count`)}</p>
                                            <p>{totalTickets}</p>
                                        </div>
                                        <div className={styles.rowTwo}>
                                            {Object.entries(groupedItems || {}).map(([groupKey, items]) => {
                                                const brand = items[0].ticket.lottery.lottery_brand_day.lottery_brand;
                                                const price = items[0].ticket.lottery.price;
                                                return (
                                                    <div key={groupKey} className={styles.ticketGroup}>
                                                        <p className={styles.grouBrandName}>{t(brand.name)}</p>
                                                        <p className={styles.grouBrandCount}>{t(`Rs`)} {price.toFixed(2)} * {items.length}</p>
                                                        <p>{t(`Rs`)} {(price * items.length).toFixed(2)}</p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className={styles.rowThree}>
                                            <p>{t(`Total`)}</p>
                                            <p>{t(`Rs`)} {totalAmount.toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.footerBtn}>
                                    {wallet?.balance >= totalAmount &&
                                        <button
                                            className={`primary-btn ${styles.purchaseBtn}`}
                                            onClick={payThroughWallet}
                                            disabled={isWalletOrderCreating}>
                                            {isWalletOrderCreating ? <BeatLoader color="#FFFFFF" /> : `Wallet Pay`}
                                        </button>
                                    }
                                    <WebxpayPayment totalAmount={totalAmount} />
                                </div>
                            </>
                            :
                            <div className={styles.emptyImg}>
                                <img
                                    src={NoResultsFoundImg}
                                    alt="No Results Found"
                                    className={styles.noResultsImage}
                                />
                            </div>
                    }
                </div>
            </div> 
            {isOpen &&
                <>
                    <div className={styles.modal}>
                        <div className={styles.modalContainer}>
                            <div className={styles.closeRow}>
                                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                                    setOpen(false);
                                    document.body.style.overflow = 'unset';
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }} />
                            </div>
                            <div className={styles.modalBody}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <FontAwesomeIcon icon={faCheckCircle} className={styles.checkIcon}/>
                                        <p className={styles.conTitle}>Purchase Succeed</p>
                                        <p className={styles.conText}>Your ticket purchase has been successfully completed and you're now officially entered into the draw. <br/> Best of luck!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    );
};

export default Cart;